import { render, staticRenderFns } from "./GoodsCombinationStatus.vue?vue&type=template&id=6e8947bf&scoped=true"
import script from "./GoodsCombinationStatus.vue?vue&type=script&lang=js"
export * from "./GoodsCombinationStatus.vue?vue&type=script&lang=js"
import style0 from "./GoodsCombinationStatus.vue?vue&type=style&index=0&id=6e8947bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8947bf",
  null
  
)

export default component.exports